import { useFetch } from "../../hooks/useFetch";
import { Loading, EmptyState } from "../../components/States";
import { JobCard } from "../../components/JobCard";
import { ClipboardList } from "lucide-react";

export default function FieldJobs() {
  const { data, loading } = useFetch("/jobs");
  if (loading) return <Loading />;
  const jobs = data || [];

  return (
    <div className="space-y-5">
      <h1 className="font-head text-4xl font-black text-white">All Jobs</h1>
      {jobs.length === 0 ? (
        <EmptyState title="No jobs assigned" icon={ClipboardList} />
      ) : (
        <div className="space-y-4">{jobs.map((j) => <JobCard key={j.id} job={j} />)}</div>
      )}
    </div>
  );
}
